import { render, staticRenderFns } from "./EmployeeButton.vue?vue&type=template&id=5db4886a&"
import script from "./EmployeeButton.vue?vue&type=script&lang=ts&"
export * from "./EmployeeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports